export const FORMAT_DROPDOWN_OPTIONS = [
  {
    value: '',
    label: 'No Format Selected (Text)',
  },
  {
    value: 'ACTIONS',
    label: 'Actions',
  },
  {
    value: 'ADDRESS',
    label: 'Address',
  },
  {
    value: 'BANK_OR_CHECK',
    label: 'Bank / Check',
  },
  {
    value: 'CREDIT_CARD',
    label: 'Credit Card',
  },
  {
    value: 'CURRENCY',
    label: 'Currency',
  },
  {
    value: 'DATE',
    label: 'Date',
  },
  {
    value: 'TIME',
    label: 'Time',
  },
  {
    value: 'EMAIL',
    label: 'Email Address',
  },
  {
    value: 'FULL_NAME',
    label: 'Full Name',
  },
  {
    value: 'ID',
    label: 'ID Number',
  },
  {
    value: 'LINK',
    label: 'Link',
  },
  {
    value: 'LIST',
    label: 'List',
  },
  {
    value: 'PERCENT',
    label: 'Percentage',
  },
  {
    value: 'PHONE',
    label: 'Phone Number',
  },
  {
    value: 'STATUS',
    label: 'Status',
  },
  {
    value: 'SUCCESS_ERROR',
    label: 'Success / Error',
  },
  {
    value: 'PAYMENT_FREQUENCY',
    label: 'Payment Frequency',
  },
  {
    value: 'TAXID',
    label: 'Tax ID',
  },
  {
    value: 'YES_NO',
    label: 'Yes / No',
  },
];
